<div id="offline_indicator" [class.offline]="clicsService.online == false"><p>cannot connect to server</p></div>
<div id="footer_buttons">
 <clics-icon [theme]="theme" [class.disabled]="!canGoBack()" (click)="doGoBack()" [text]="'Back'"></clics-icon>
 <clics-icon [theme]="theme" [special]="activeClass=='reports'" (click)="doNavigation('reports')" [text]="'Reports'"></clics-icon>
 <clics-icon [theme]="theme" [special]="activeClass=='admin'" (click)="doSettingsNavigation()" [text]="'Settings@footer'"></clics-icon>
 <clics-icon [theme]="theme" (click)="showHelp()" [text]="'Help'"></clics-icon>
 <clics-icon [theme]="theme" (click)="goStartPage()" [text]="'Sign Out'"></clics-icon>
</div>
